import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedFileUploadRoutingModule } from './shared-file-upload-routing.module';
import { UploadFilesComponent } from './upload-files/upload-files.component';

@NgModule({
  declarations: [UploadFilesComponent],
  imports: [
    CommonModule,
    SharedFileUploadRoutingModule
    ],
    exports: [UploadFilesComponent],
})
export class SharedFileUploadModule { }
